import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';

const Header = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light shadow-sm bg-white py-3">
            <div className="container d-flex align-items-center justify-content-between">
                <Link className="navbar-brand fw-bold text-primary fs-3" to="/">
                    <img
                        src={logo}
                        alt="Local Hire Logo"
                        style={{ width: '60px', height: '60px', marginRight: '10px' }} // Ajusta el tamaño y el margen
                    />  
                    <h3 className="d-inline font-inter">
                    Local Hire
                    </h3>
                </Link>
                <button
                    className="navbar-toggler border-0"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-center">
                        <li className="nav-item me-2">
                            <Link className="nav-link text-dark fw-medium px-3 rounded-pill py-2 shadow-sm" to="/">
                                Inicio
                            </Link>
                        </li>
                        <li className="nav-item me-2">
                            <Link className="nav-link text-dark fw-medium px-3 rounded-pill py-2 shadow-sm" to="/servicelink">
                                Servicios
                            </Link>
                        </li>
                        <li className="nav-item me-2">
                            <Link className="nav-link text-dark fw-medium px-3 rounded-pill py-2 shadow-sm" to="/login">
                                Login
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="btn btn-primary rounded-pill px-4 py-2 shadow-sm" to="/beone">
                                Convertite en un Local Hire
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
